import { useCallback, useState } from 'react';
import { ActionButton } from '@library/components/buttons';
import { FileUploaderModal } from '@library/components/modals/FileUploaderModal';
import Upload from '@library/assets/images/Upload.svg';
import { useUploadMemberGroupsByCSVMutation } from '@bo-services/members/memberGroupsApi';

export function MemberGroupsCSVUpload() {
  const [open, setOpen] = useState<boolean>(false);
  const [importRequestId, setImportRequestId] = useState(0);

  const [uploadMemberGroupsCSV, { error, isLoading, isSuccess, reset }] =
    useUploadMemberGroupsByCSVMutation();

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  const onFileUpload = useCallback(
    async (file: File | null) => {
      if (!file) return;

      const formData = new FormData();
      formData.append('csv', file);

      const result = await uploadMemberGroupsCSV(formData).catch(() => {});

      if (result && 'data' in result && result.data) {
        const importRequestID = result.data.import_request_id;
        setImportRequestId(importRequestID);
      }
    },
    [uploadMemberGroupsCSV]
  );

  return (
    <>
      <ActionButton
        title="Upload CSV"
        variant="secondary"
        handleOnClick={openModal}
        className="flex items-center justify-center gap-2 px-3 py-2 text-base font-medium"
      >
        <img src={Upload} alt="" className="h-[1.25em]" />
        Upload CSV
      </ActionButton>
      <FileUploaderModal
        active={open}
        onCancelModal={closeModal}
        onFileUpload={onFileUpload}
        additionalMessageInfo={
          importRequestId ? `Your Import Request ID is: ${importRequestId}` : ''
        }
        isUploadError={Boolean(error)}
        isUploading={isLoading}
        isUploadSuccess={isSuccess}
        loadingMessage="Validating CSV and updating member group assignments"
        resetUploadAPI={reset}
        uploadError={error}
      />
    </>
  );
}
